module.exports = __webpack_public_path__ + "img/zicon.f10a6913.png";